import { Box, makeStyles, Typography } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import * as React from "react";
import { FC } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { backToStep } from "../../store/engine/engineReducer";
import { Step } from "../../types/Step";
import { BackModal } from "../modals/BackModal";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 806,
    borderRadius: 10,
    backgroundColor: theme.palette.secondary.light,
    boxShadow: "0 4px 12px 0 rgba(13,12,12,0.02), 0 10px 30px 0 rgba(0,0,0,0.12)",
    padding: 42,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      height: "unset",
      minHeight: "100vh",
      width: 300,
      padding: 30,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
  },
  paperSwipeableDrawer: {
    [theme.breakpoints.down("sm")]: {
      height: "100vh",
    },
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
    position: "absolute",
    top: 0,
    right: 0,
  },
  spacer: {
    width: "100%",
    height: 73,
  },
  commonPanelRoot: {
    height: "100%",
  },
  iconButtonClose: {
    color: "white",
  },
  title: {
    marginBottom: 40,
  },
  step: {
    marginBottom: 10,
    marginTop: 30,
  },
  multipleBox: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 5,
    marginBottom: 9,
  },
  boxDivider: {
    width: "calc(100% - 26px)",
    height: 1,
    background: theme.palette.secondary.light,
    margin: "7px 13px",
  },
  box: {
    minHeight: 64,
    borderRadius: 5,
    backgroundColor: theme.palette.secondary.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    paddingLeft: 10,
    marginBottom: 9,
    position: "relative",
  },
  boxWithoutMargin: {
    marginBottom: 0,
  },
  boxText: {
    display: "flex",
    flexDirection: "column",
  },
  boxTitle: {
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
  boxDescription: {
    color: theme.palette.common.white,
  },
  boxInfoIcon: {
    color: "white",
    position: "absolute",
    width: 16,
    height: 16,
    top: 8,
    right: 10,
    cursor: "pointer",
  },
  boxIcon: {
    marginTop: 10,
    cursor: "pointer",
  },
  footerPrice: {
    color: theme.palette.primary.main,
  },
  footerDisclaimer: {
    fontSize: 12,
  },
  allungaPanelMd: {
    height: 400,
  },
}));

interface BasicBoxProps {
  withBack: boolean;
  icon: React.ReactElement;
  step: Step;
  title: string;
  description?: React.ReactElement;
  infoCallBack?: () => void;
  noBottomMargin?: boolean;
}

export const BasicBox: FC<BasicBoxProps> = (props: BasicBoxProps) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  const onClick = (): void => setOpen(true);
  const handleClose = (): void => setOpen(false);
  const handleConfirm = (): void => {
    setOpen(false);
    dispatch(backToStep(props.step, history));
  };

  const icon = props.withBack ? React.cloneElement(props.icon, { onClick }) : props.icon;
  const boxClassName = `${classes.box} ${props.noBottomMargin ? classes.boxWithoutMargin : ""}`;

  return (
    <Box className={boxClassName} data-test={`box-${props.title}`}>
      <Box className={classes.boxIcon}>{icon}</Box>
      <BackModal handleConfirm={handleConfirm} handleClose={handleClose} open={open} />
      <Box className={classes.boxText}>
        <Typography variant={"body2"} className={classes.boxTitle}>
          {props.title}
        </Typography>
        {props.description && (
          <Typography className={classes.boxDescription} variant={"body2"}>
            {props.description}
          </Typography>
        )}
        {props.infoCallBack && <InfoIcon className={classes.boxInfoIcon} onClick={props.infoCallBack} />}
      </Box>
    </Box>
  );
};

export const MultipleBox: FC = (props) => {
  const classes = useStyles();
  return (
    <Box className={classes.multipleBox}>
      {/* eslint-disable-next-line react/prop-types */}
      {props.children}
    </Box>
  );
};

export const BoxDivider: FC = () => {
  const classes = useStyles();
  return <div className={classes.boxDivider}></div>;
};
